import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components/macro';

interface ScLayoutProps {
  realHeight: number | null;
  withEmailConfirmationPopup: boolean;
  emailConfirmationPopupHeight: number;
}

export const ScLayout = styled.div<ScLayoutProps>`
  position: relative;
  min-height: ${({ realHeight }) => (realHeight ? `${realHeight}px` : '100vh')};
  top: ${({ withEmailConfirmationPopup, emailConfirmationPopupHeight }) =>
    withEmailConfirmationPopup ? `${emailConfirmationPopupHeight}px` : 0};
  transition: margin-top 0.3s;
  display: flex;
  flex-direction: column;
`;

export const ScMain = styled.div<Pick<ScLayoutProps, 'realHeight'>>`
  display: flex;
  flex-direction: column;
  min-height: ${({ realHeight }) => (realHeight ? `${realHeight}px` : '100vh')};
  padding-left: 184px;
  transition: all 0.5s;
  overflow: clip;

  @media print {
    padding: 0;
  }

  @media (${device.mobile}) {
    padding-left: 0px;
  }
`;
